// Turns an error from the syncMechanicalKeyInsertBlade callable into a message
// the user can act on. The raw error is still sent to the error logs.
export function getSyncErrorMessage(error) {
  const code = ((error && error.code) || "").toString().replace("functions/", "");
  const message = ((error && error.message) || "").toString();
  const offline = typeof navigator !== "undefined" && navigator.onLine === false;

  if (offline) {
    return "You are offline. Your changes were not saved. Check your internet connection and try again.";
  }

  if (
    code === "unavailable" ||
    code === "deadline-exceeded" ||
    /network|failed to fetch|timeout|timed out/i.test(message)
  ) {
    return "Network problem: could not reach the server, so your changes were not saved. Check your connection and try again.";
  }

  switch (code) {
    case "unauthenticated":
      return "Your session has expired. Please log in again, then retry.";
    case "permission-denied":
      return "You do not have permission to make this change.";
    case "not-found":
      return `${message || "The record was not found"}. It may have been deleted or changed by someone else. Refresh the page and try again.`;
    case "already-exists":
    case "invalid-argument":
      return message;
    case "resource-exhausted":
      return "The server is busy right now. Please wait a moment and try again.";
    case "internal":
    case "unknown":
    default:
      return "Something went wrong on the server and your changes were not saved. Please try again. If it keeps happening, contact support.";
  }
}
